/* eslint no-underscore-dangle: 0 */
import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-toolbox/lib/button';
import { list2, available as getAvailable, active as getActive, start } from '~/actions/work';
import Title from '~/components/Title';
import Tag from '~/components/Tag';
import Work from '~/components/Work';
import Spinner from '~/components/Spinner';
import ContainerPicker from '~/components/ContainerPicker';
import UserPicker from '~/components/UserPicker';
import ActionPicker from '~/components/ActionPicker';

import styleLocal from './style.scss';

class WorkPage extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
    router: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      available: {},
      loading: true,
      results: [],
      query: '',
    };
  }

  componentDidMount() {
    getAvailable(this.props.dispatch, this.context.apiClient)
      .then(r => this.setState({ available: r.data }));
    getActive(this.props.dispatch, this.context.apiClient);
    this.search();
  }

  search() {
    this.setState({ loading: true });
    list2(
      this.props.dispatch,
      this.context.apiClient,
      this.state.query,
      null,
      this.state.actionId,
      this.state.userId,
      this.state.containerId,
    ).then(r => this.setState({
      results: r.data.results,
      skipId: r.data.skipId,
      more: r.data.more,
      loading: false,
    }));
  }

  loadMore() {
    this.setState({ loading: true });
    list2(
      this.props.dispatch,
      this.context.apiClient,
      this.state.query,
      this.state.skipId,
      this.state.actionId,
      this.state.userId,
      this.state.containerId,
    ).then(r => this.setState({
      results: [...this.state.results, ...r.data.results],
      skipId: r.data.skipId,
      more: r.data.more,
      loading: false,
    }));
  }

  workStart(actionId, data) {
    start(this.props.dispatch, this.context.apiClient, actionId, data)
      .then(() => getAvailable(this.props.dispatch, this.context.apiClient))
      .then(r => this.setState({ available: r.data }));
  }

  renderAvailable(key, item) {
    return (
      <div key={key} className={styleLocal.available}>
        <div>Action: <Tag type="action" id={item.actionId} /></div>
        {item.data.containerId && <div>Container: <Tag type="container" id={item.data.containerId} /></div>}
        {item.data.orderId && <div>Order: <Tag type="order" id={item.data.orderId} /></div>}
        <Button label="Start work" icon="play_arrow" className={styleLocal.start} onClick={() => this.workStart(item.actionId, item.data)} />
      </div>
    );
  }

  render() {
    const { available } = this.state;
    const active = Object.values(this.props.items)
      .filter(i => i.userId === this.props.userId && !i.finish)
      .map(i => i.id);
    return (
      <div style={{ padding: '10px' }}>
        <div className={styleLocal.title}>Work</div>
        <Title style={{ marginBottom: '10px' }}>My active work</Title>
        {active.map(id => <Work key={id} id={id} style={{ margin: '5px 5px 0px 0px' }} />)}
        {active.length === 0 && <div>No work found</div>}
        <Title style={{ margin: '10px 0' }}>Available</Title>
        {Object.keys(available)
          .reduce((s, v) => [...s, ...available[v].map(e => ({ actionId: v, data: e }))], [])
          .map((v, i) => this.renderAvailable(i, v))
        }
        {Object.keys(available)
          .filter(i => available[i].length > 0)
          .length === 0 && <div>No work found</div>}
        <Title style={{ margin: '10px 0' }}>Search</Title>
        <form style={{ marginBottom: 15 }} onSubmit={e => { e.preventDefault(); this.search(); }}>
          <input
            placeholder="Search SKU, ID"
            className={styleLocal.searchField}
            value={this.state.query}
            onChange={e => this.setState({ query: e.target.value })}
          />
          <Button label="Find" primary raised type="submit" />
        </form>
        <div className={styleLocal.filters}>
          <b>Filters</b>
          <div className={styleLocal.filter}>
            <div className={styleLocal.label}>Action</div>
            <div className={styleLocal.item}>
              <ActionPicker
                value={this.state.actionId}
                onChange={actionId => this.setState({ actionId }, this.search)}
              />
            </div>
          </div>
          <div className={styleLocal.filter}>
            <div className={styleLocal.label}>User</div>
            <div className={styleLocal.item}>
              <UserPicker
                value={this.state.userId}
                onChange={userId => this.setState({ userId }, this.search)}
              />
            </div>
          </div>
          <div className={styleLocal.filter}>
            <div className={styleLocal.label}>Container</div>
            <div className={styleLocal.item}>
              <ContainerPicker
                value={this.state.containerId}
                onChange={containerId => this.setState({ containerId }, this.search)}
              />
            </div>
          </div>
        </div>
        {!this.state.loading && this.state.results
          .map(item => (<Work key={item.id} id={item.id} style={{ margin: '5px 5px 0px 0px' }} />))}
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {this.state.loading && <Spinner />}
          {!this.state.loading && this.state.results.length === 0 && <div>No work found</div>}
          {!this.state.loading && this.state.more && <Button
            label="Load more"
            primary
            raised
            onClick={() => this.loadMore()}
          />}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userId: state.getIn(['user', 'self', 'userId']),
  items: state.getIn(['work', 'items']).toJS(),
});

export default connect(mapStateToProps)(WorkPage);



// WEBPACK FOOTER //
// ./app/pages/Work/index.js